import * as React from "react";
import {
  Dimensions,
  Pressable,
  ScaledSize,
  ScrollView,
  StyleSheet,
} from "react-native";
import { View, Text } from "../../components/Themed";
import { Button } from "react-native-elements";
import { Ionicons } from "@expo/vector-icons";
import { kcColor } from "../../constants/Colors";
import { kcSetState, kcSetUnmount } from "../../kcExternal";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import { BottomTabParamList, TabTECPParamList } from "../../types";
import { BottomTabNavigationProp } from "@react-navigation/bottom-tabs";
import TECPSetting, {
  MaSetting,
  TECPSettingHelper,
} from "../../kcTECP/TECPSetting";
import { TECPSettingEditHelper } from "../../kcTECP";
import TECPSettingControl from "../../components/kcTECPSettingControl";

type IState = {
  bFixedRedraw: boolean; // 笨方式 用來強制繪圖
  bIsScreenFocus: boolean;
  loading: boolean;
  DimensionsWindow: ScaledSize;
};

type IProp = {
  route: RouteProp<TabTECPParamList, "TabTECPScreen_Setting_MA">;
  navigation: CompositeNavigationProp<
    StackNavigationProp<TabTECPParamList, "TabTECPScreen_Setting_MA">,
    BottomTabNavigationProp<BottomTabParamList, "TabTECP">
  >;
};

export default class TECPScreen_Setting_MA extends React.Component<
  IProp,
  IState
> {
  constructor(props: any) {
    super(props);

    if (TECPSettingEditHelper.SettingBuffer)
      this.m_TECPSetting = TECPSettingEditHelper.SettingBuffer.Setting;
    else this.m_TECPSetting = TECPSettingHelper.CreateDefault();
  }

  state: IState = {
    loading: false,
    bFixedRedraw: false, // 笨方式 用來強制繪圖
    bIsScreenFocus: true,
    DimensionsWindow: Dimensions.get("window"),
  };

  m_TECPSetting: TECPSetting;
  m_ControlRef_Ma0 = React.createRef<TECPSettingControl>();
  m_ControlRef_Ma1 = React.createRef<TECPSettingControl>();
  m_ControlRef_Ma2 = React.createRef<TECPSettingControl>();
  m_ControlRef_Ma3 = React.createRef<TECPSettingControl>();

  componentDidMount() {
    this.props.navigation.addListener("focus", this.OnFocus);
    this.props.navigation.addListener("blur", this.OnBlur);
    Dimensions.addEventListener("change", this.OnDimensionsChange);

    this.props.navigation.setOptions({
      headerLeft: this.Render_HeaderLeft,
      headerRight: this.Render_HeaderRight,
      headerTitle: this.Render_HeaderTitle,
    });
  }

  componentWillUnmount() {
    this.props.navigation.removeListener("focus", this.OnFocus);
    this.props.navigation.removeListener("blur", this.OnBlur);
    Dimensions.removeEventListener("change", this.OnDimensionsChange);

    kcSetUnmount(this, true);
  }

  private FixedRedrawUI = () => {
    kcSetState(this, { bFixedRedraw: !this.state.bFixedRedraw }); // 強制更動畫面
  };
  private InitSetting = async () => {
    if (TECPSettingEditHelper.SettingBuffer) {
      let setting = await TECPSettingEditHelper.SettingBuffer.GetSettingAsync(
        true
      );
      this.RefreshSettingControl();
    }
  };
  private RestoreSetting = () => {
    TECPSettingEditHelper.SettingBuffer?.ReSet();
  };
  private SaveSetting = () => {
    TECPSettingEditHelper.SettingBuffer?.Save();
  };
  private ToDefaultSetting = () => {
    this.m_TECPSetting.KLine_Ma0.ToDefault(0);
    this.m_TECPSetting.KLine_Ma1.ToDefault(1);
    this.m_TECPSetting.KLine_Ma2.ToDefault(2);
    this.m_TECPSetting.KLine_Ma3.ToDefault(3);

    this.RefreshSettingControl();
  };
  private RefreshSettingControl = () => {
    this.m_ControlRef_Ma0.current?.SetInputValue(
      this.m_TECPSetting.KLine_Ma0.MaDayBase
    );
    this.m_ControlRef_Ma1.current?.SetInputValue(
      this.m_TECPSetting.KLine_Ma1.MaDayBase
    );
    this.m_ControlRef_Ma2.current?.SetInputValue(
      this.m_TECPSetting.KLine_Ma2.MaDayBase
    );
    this.m_ControlRef_Ma3.current?.SetInputValue(
      this.m_TECPSetting.KLine_Ma3.MaDayBase
    );
    this.FixedRedrawUI();
  };
  private GoBack = () => {
    this.props.navigation.pop();
  };

  /*---------------------------------------------------------------------------- */
  private OnFocus = () => {
    this.InitSetting();
    kcSetState(this, { bIsScreenFocus: true });
  };
  private OnBlur = () => {
    kcSetState(this, { bIsScreenFocus: false });
  };
  private OnDimensionsChange = ({
    window,
    screen,
  }: {
    window: ScaledSize;
    screen: ScaledSize;
  }) => {
    this.setState({ DimensionsWindow: window });
  };
  private OnHeadLeftClick = () => {
    this.RestoreSetting();
    this.GoBack();
  };
  private OnHeadRightClick = () => {
    this.ToDefaultSetting();
  };
  private OnSettingChange = (_MaSetting: MaSetting, _Value: number) => {
    _Value = Math.floor(_Value);
    _MaSetting.MaDayBase = _Value;
    this.FixedRedrawUI();
  };
  private OnSaveClick = () => {
    this.SaveSetting();
    this.GoBack();
  };

  private Render_HeaderLeft = () => {
    return (
      <Button
        // style={{ width: 48, height: 48 }}
        icon={
          <Ionicons name="ios-chevron-back" size={24} color={kcColor("Icon")} />
        }
        iconContainerStyle={{ alignSelf: "center" }}
        buttonStyle={styles.Head_Left_ButtonStyle}
        onPress={this.OnHeadLeftClick}
      />
    );
  };

  private Render_HeaderRight = () => {
    return (
      <Pressable
        style={{
          flex: 1,
          justifyContent: "center",
          padding: 5,
        }}
        onPress={this.OnHeadRightClick}
      >
        <Text style={{ color: "white" }} selectable={false}>
          恢復預設值
        </Text>
      </Pressable>
    );
  };

  private Render_HeaderTitle = () => {
    return (
      <View
        style={{
          backgroundColor: "#00000000",
          //flex: 1,
          width: 300,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text
          style={{
            backgroundColor: "#00000000",
            color: kcColor("Title"),
            fontSize: 18,
          }}
          selectable={false}
        >
          {"MA"}
        </Text>
      </View>
    );
  };

  /*-------------------------------------------------*/
  private Render_SettingControls = () => {
    if (!TECPSettingEditHelper.SettingBuffer?.SettingReady) return <></>;
    return (
      <>
        <TECPSettingControl
          style={{ marginTop: 10, marginBottom: 5 }}
          ref={this.m_ControlRef_Ma0}
          Mode="NumberInput"
          Text="週期1"
          SubText="範圍: 2-999"
          OnTextClick="Default"
          TextStyle={{ color: this.m_TECPSetting.KLine_Ma0.LineColor }}
          InitInputValue={this.m_TECPSetting.KLine_Ma0.MaDayBase}
          InputValueProp={{ FloatNum: 0, Min: 2, Max: 999 }}
          OnInputValueChanged={(_Value) =>
            this.OnSettingChange(this.m_TECPSetting.KLine_Ma0, _Value)
          }
        />
        <TECPSettingControl
          style={{ marginTop: 5, marginBottom: 5 }}
          ref={this.m_ControlRef_Ma1}
          Mode="NumberInput"
          Text="週期2"
          SubText="範圍: 2-999"
          OnTextClick="Default"
          TextStyle={{ color: this.m_TECPSetting.KLine_Ma1.LineColor }}
          InitInputValue={this.m_TECPSetting.KLine_Ma1.MaDayBase}
          InputValueProp={{ FloatNum: 0, Min: 2, Max: 999 }}
          OnInputValueChanged={(_Value) =>
            this.OnSettingChange(this.m_TECPSetting.KLine_Ma1, _Value)
          }
        />
        <TECPSettingControl
          style={{ marginTop: 5, marginBottom: 5 }}
          ref={this.m_ControlRef_Ma2}
          Mode="NumberInput"
          Text="週期3"
          SubText="範圍: 2-999"
          OnTextClick="Default"
          TextStyle={{ color: this.m_TECPSetting.KLine_Ma2.LineColor }}
          InitInputValue={this.m_TECPSetting.KLine_Ma2.MaDayBase}
          InputValueProp={{ FloatNum: 0, Min: 2, Max: 999 }}
          OnInputValueChanged={(_Value) =>
            this.OnSettingChange(this.m_TECPSetting.KLine_Ma2, _Value)
          }
        />
        <TECPSettingControl
          style={{ marginTop: 5, marginBottom: 10 }}
          ref={this.m_ControlRef_Ma3}
          Mode="NumberInput"
          Text="週期4"
          SubText="範圍: 2-999"
          OnTextClick="Default"
          TextStyle={{ color: this.m_TECPSetting.KLine_Ma3.LineColor }}
          InitInputValue={this.m_TECPSetting.KLine_Ma3.MaDayBase}
          InputValueProp={{ FloatNum: 0, Min: 2, Max: 999 }}
          OnInputValueChanged={(_Value) =>
            this.OnSettingChange(this.m_TECPSetting.KLine_Ma3, _Value)
          }
        />
      </>
    );
  };
  render() {
    const EffectiveHeigh = this.state.DimensionsWindow.height - 60;
    return (
      <View
        style={{
          backgroundColor: kcColor("Background"),
          height: EffectiveHeigh,
        }}
      >
        <ScrollView style={{ flex: 1 }}>
          <View
            style={{
              flex: 1,
              flexDirection: "column",
              backgroundColor: kcColor("Background"),
            }}
          >
            <View
              style={{
                flex: 1,
                flexDirection: "column",
                backgroundColor: "#00000000",
              }}
            >
              {this.Render_SettingControls()}

              <Button
                style={{ margin: 20, marginBottom: 0, marginTop: 15 }}
                buttonStyle={{
                  backgroundColor: kcColor("Blue"),
                  borderRadius: 15,
                }}
                onPress={this.OnSaveClick}
                title="儲存"
              />
            </View>
          </View>
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  Head_Left_ButtonStyle: {
    backgroundColor: "#00000000",
    borderColor: "red",
    borderWidth: 0,
    borderRadius: 15,
  },
  button: {
    backgroundColor: "#00000000",
    borderColor: "red",
    borderWidth: 0,
    borderRadius: 15,
  },
});
